import { lowerFirst } from 'lodash';
import { getContentSchemaFromContentFul } from '../../../../../redux/actions/common/common-action';
import { EU, EXCEPTIONAL_EU_ADDRESS_COUNTRIES } from '../../../../../utils/constants';
import {
  OnBoarding,
  ekycService,
  scheduleAppointmentData,
  screenSettings,
  VerificationHolding,
  addressFieldKeyMap
} from './constants';
import {
  IDynamicInputField,
  IScreenComponentFields,
  IStepperComponentField,
  OnboardingStepperCmsData
} from './Interface';
import { AppDispatch } from '../../../../../store.type';
import { setEKYCCMSDataAction } from '@Redux/actions/onboarding/new-onboarding-action';

export const ROUTE_KEYS = {
  MobileNumberScreen: 'MobileNumberScreen',
  OnBoardingPersonalInfo: 'OnBoardingPersonalInfo',
  DocumentInformation: 'DocumentInformation',
  IdentityCheck: 'IdentityCheck',
  RetrievedInformation: 'RetrievedInformation',
  EditYourInformation: 'EditYourInformation',
  EmploymentInformation: 'EmploymentInformation',
  AddressInformation: 'AddressInformation',
  AccountUsage: 'AccountUsage'
};

export const getCMSStepperData = async (
  screen: string,
  countryCode: string
): Promise<OnboardingStepperCmsData | undefined> => {
  const cmsDataResponse = await getContentSchemaFromContentFul(
    'pageStepperViewData',
    'STEPPER_VIEW_DATA'
  );
  const stepperCmsData = getOnboardingStepperCmsData(
    cmsDataResponse?.stepperData?.value,
    screen,
    countryCode
  );
  return stepperCmsData;
};

const getOnboardingStepperCmsData = (
  data: any[],
  screenName: string,
  countryCode: string
): OnboardingStepperCmsData | undefined => {
  const formatedScreenName = lowerFirst(screenName);
  const cmsDataIndex = data?.findIndex(
    (item) => item?.target?.fields?.title?.value.toLowerCase() === formatedScreenName.toLowerCase()
  );
  const inputFields = data?.[cmsDataIndex]?.target?.fields?.inputFields?.value;
  const dynamicInputFields = data?.[cmsDataIndex]?.target?.fields?.dynamicInputFields?.value;
  const cmsScreenData = data?.[cmsDataIndex]?.target?.fields?.details?.value?.filter(
    (item: IStepperComponentField) => item.countryCode?.includes(countryCode)
  )[0]?.stepperData;
  const getDefaultData = OnBoarding[formatedScreenName as keyof typeof OnBoarding].filter(
    (item: IStepperComponentField) => item.countryCode?.includes(countryCode)
  )[0]?.stepperData;
  return {
    heading: cmsScreenData?.heading || getDefaultData?.heading,
    description: cmsScreenData?.description || getDefaultData?.description,
    primaryBtnText: cmsScreenData?.primaryBtnText || getDefaultData?.primaryBtnText,
    secondaryBtnText: cmsScreenData?.secondaryBtnText || getDefaultData?.secondaryBtnText,
    footerText: cmsScreenData?.footerText || getDefaultData?.footerText,
    footerText1: cmsScreenData?.footerText1 || getDefaultData?.footerText1,
    onboardingConsent: cmsScreenData?.onboardingConsent || getDefaultData?.onboardingConsent,
    skip: cmsScreenData?.skip || getDefaultData?.skip,
    inputFields,
    dynamicInputFields,
    sendCountries: cmsScreenData?.sendCountries || getDefaultData?.sendCountries,
    estimatedMonthlyVolume:
      cmsScreenData?.estimatedMonthlyVolume || getDefaultData?.estimatedMonthlyVolume,
    primaryReasonForTransfer:
      cmsScreenData?.primaryReasonForTransfer || getDefaultData?.primaryReasonForTransfer,
    addMore: cmsScreenData?.addMore || getDefaultData?.addMore,
    showAll: cmsScreenData?.showAll || getDefaultData?.showAll,
    reason: cmsScreenData?.reason || getDefaultData?.reason,
    country: cmsScreenData?.country || getDefaultData?.country,
    pep: cmsScreenData?.pep || getDefaultData?.pep,
    pepToolTip: cmsScreenData?.pepToolTip || getDefaultData?.pepToolTip,
    primaryReasonForTransferPlaceHolder:
      cmsScreenData?.primaryReasonForTransferPlaceHolder ||
      getDefaultData?.primaryReasonForTransferPlaceHolder
  };
};

export const getScreensData = (screenName: string, countryCode: string): IScreenComponentFields => {
  return screenSettings[lowerFirst(screenName) as keyof typeof screenSettings].filter(
    (item: IScreenComponentFields) => item.countryCode?.includes(countryCode)
  )[0];
};

export const getInputFieldByName = (
  inputFields: any[] | undefined,
  title: string
): Record<string, string> => {
  const inputItem = inputFields?.find((item) => item.target?.fields?.title?.value === title);
  return {
    label: inputItem?.target?.fields?.label?.value,
    placeHolder: inputItem?.target?.fields?.placeHolder?.value
  };
};
export const getCMSEKYCData = async (countryCode: string, dispatch: AppDispatch): Promise<any> => {
  const cmsDataResponse = await getContentSchemaFromContentFul('pageJsonDataView', 'EKYC_SERVICE');
  return getOnboardingekycCmsData(
    cmsDataResponse?.labels?.value,
    countryCode,
    cmsDataResponse?.labels?.value?.ekycServiceDown,
    dispatch
  );
};

export const getVerifyScreenCMSData = async (): Promise<any> => {
  const cmsDataResponse = await getContentSchemaFromContentFul(
    'page4OnBoardingAcknowledgeInformation',
    'MOBILE_ONBOARDING_ACKNOWLEDGE_INFORMATION'
  );
  return {
    verificationText:
      cmsDataResponse?.verificationText?.value || VerificationHolding.verificationText,
    fewMomentsText: cmsDataResponse?.fewMomentsText?.value || VerificationHolding.fewMomentsText,
    holdingVerifyScreenTimerInMiliSeconds:
      cmsDataResponse?.holdingVerifyScreenTimerInMiliSeconds?.value ||
      VerificationHolding.holdingVerifyScreenTimerInMiliSeconds
  };
};

const getOnboardingekycCmsData = (
  data: Record<string, any>,
  countryCode: string,
  ekycServiceCMSResponse: Record<string, string>,
  dispatch: AppDispatch
): any => {
  const ekycServiceDataArray: any[] = data?.ekycService;
  type kycReviewDataCMSType = keyof typeof ekycService.kycDataReview;

  const kycReviewDataCMS =
    data?.kycDataReview?.[countryCode] ||
    ekycService.kycDataReview[countryCode as kycReviewDataCMSType];
  const ekycServiceData = ekycServiceDataArray?.filter((item) =>
    item.countryCode?.includes(countryCode)
  );
  const defaultEkycServiceData = ekycService.ekycService?.filter((item) =>
    item.countryCode?.includes(countryCode)
  );
  const responseData = ekycServiceData?.[0]?.ekycData || defaultEkycServiceData[0]?.ekycData;
  dispatch(
    setEKYCCMSDataAction({
      ekycData: responseData,
      kycDataReview: kycReviewDataCMS
    })
  );
  return {
    ...responseData,
    ekycServiceDownHeading:
      ekycServiceCMSResponse?.ekycServiceDownHeading || ekycService.ekycServiceDownHeading,
    retryEkyc: ekycServiceCMSResponse?.retryEkyc || ekycService.retryEkyc,
    proceedWithManualUpload:
      ekycServiceCMSResponse?.proceedWithManualUpload || ekycService.proceedWithManualUpload
  };
};

export const getCountrySpecificInputFields = (
  dynamicInputFields: any[] | undefined,
  countryCode: string
): any[] => {
  const inputFields = dynamicInputFields?.filter((item: IDynamicInputField) =>
    item.countryCode?.includes(countryCode)
  )[0]?.inputFields;
  return inputFields || [];
};

export const areAllValuesEmpty = (
  getAllFormObj: string | number | any,
  contentCountryCodeForAddress: string
): boolean => {
  const requiredAddressFields = addressFieldKeyMap[contentCountryCodeForAddress];
  const actualAddressFields: Record<string, any> = {};

  for (const key in requiredAddressFields) {
    if (Object.prototype.hasOwnProperty.call(getAllFormObj, key)) {
      actualAddressFields[key] = getAllFormObj[key];
    }
  }

  for (const key in actualAddressFields) {
    if (Object.prototype.hasOwnProperty.call(actualAddressFields, key)) {
      const value = actualAddressFields[key];
      if (typeof value === 'boolean') {
        continue;
      }
      if (value === null || value === undefined || value === '') {
        continue;
      }
      if (typeof value === 'object') {
        if (!areAllValuesEmpty(value, contentCountryCodeForAddress)) {
          return false;
        }
      } else {
        return false;
      }
    }
  }
  return true;
};

export const getContentCountryCode = (countryCode: string): string => {
  return EU.includes(countryCode) ? 'EU' : countryCode;
};

export const getConsentCountryCodeForAddress = (countryCode: string): string => {
  if (EXCEPTIONAL_EU_ADDRESS_COUNTRIES.includes(countryCode)) return countryCode;
  return EU.includes(countryCode) ? 'EU' : countryCode;
};

const getOnboardingScheduleVerificationData = (data: any[], countryCode: string): any => {
  const schedulevisitData = data?.filter((item) => item.countryCode?.includes(countryCode));
  const defaultScheduleVisiteData = scheduleAppointmentData.scheduleAppointmentData?.filter(
    (item) => item.countryCode?.includes(countryCode)
  );
  const responseData = schedulevisitData || defaultScheduleVisiteData;
  return {
    appointmentConfirmationData: responseData[0]?.appointmentConfirmationData,
    scheduleVerificationData: responseData[0]?.scheduleVerificationData
  };
};

export const getScheduleVerificationData = async (countryCode: string): Promise<any> => {
  const cmsDataResponse = await getContentSchemaFromContentFul(
    'pageJsonDataView',
    'SCHEDULE_VERIFICATION_VIEW_DATA'
  );
  return getOnboardingScheduleVerificationData(cmsDataResponse?.labels?.value, countryCode);
};
